import "core-js/modules/es.array.push.js";
import { productColumns } from '../../index.js';
import { formatTimes } from '@/utils/index.js';
import { mapMutations } from 'vuex';
import { getInfo } from '@/api/modules/personal.js';
export default {
  data() {
    return {
      PageOptions: {
        page: 1,
        per: 10
      },
      productdata: [],
      productColumns: productColumns
    };
  },
  computed: {
    pagination() {
      return {
        current: this.PageOptions.page,
        'page-size': this.PageOptions.per,
        total: this.total,
        'show-quick-jumper': true,
        'show-size-changer': true,
        'show-total': () => `总共 ${this.total} 条`,
        onChange: this.changePageOptions
      };
    }
  },
  methods: {
    ...mapMutations({
      setUseProduct: 'user/setUseProduct'
    }),
    async getUserInfo() {
      await getInfo().then(res => {
        if (res.code === 1) {
          let arr = [];
          const {
            result
          } = res;
          // this.customer_name = result.customer_name;
          this.customer_name = result.username;
          result.presentation_permissions.forEach(item => {
            item.start_time = formatTimes(item.start_time, 'YYYY-MM-DD hh:mm:ss'), item.end_time = formatTimes(item.end_time, 'YYYY-MM-DD hh:mm:ss');
            arr.push(item);
          });
          this.setUseProduct(result.presentation_permissions), this.productdata = arr;
        }
      });
    }
  },
  created() {
    this.getUserInfo();
  }
};